import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { ExternalValuationProps, getUnitTypeAndSubType } from "./index";
import PageContent from "@my-dld/components/PageContent";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { ExternalValuationApi } from "../../valuationapi";
import PageTitle from "@my-dld/components/PageTitle";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import { ExValLookUp, ExValLookupData, ValuationDetails, ValuationRequestDetails } from "../../valuationapi/entities";
import { CurrencyUtil, DateUtil, LocaleUtil } from "@eres/core";
import { TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { populateExValLookup } from "../../valuationapi/services";
import { formatAppDate } from "@my-dld/utils/Utils";

interface Props extends ExternalValuationProps {

}

interface LookupState {
	PropertyTypes?: ExValLookupData[];
}

interface State extends ValuationRequestDetails, ValuationDetails, LookupState {
	valuationCompleted: boolean;
	property: any;
}

class EVRequestDetails extends Component<Props, State> {
	apiHandler: any;
	apiExHandler: any;
	propertyId: any;

	constructor( props: ExternalValuationProps ) {
		super( props );
		this.state = {
			property: undefined,
			valuationCompleted: false,
			community: "",
			municipalityNumber: "",
			areaSizeSqMtReq: "",
			valuationScope: "",
			valuationReason: "",
			valuationCompany: "",
			notesReq: "",
			valuer: "",
			valuerCardNumber: "",
			areaSizeSqMt: "",
			areaSizeSqFt: "",
			buildUpAreaSqMt: "",
			buildUpAreaSqFt: "",
			worthSqMt: "",
			worthSqFt: "",
			totalPropertyWorth: "",
			dateOfValuation: "",
			notes: "",
			documentURL: undefined,
			rejectionReason: undefined
		};
	}

	componentDidMount() {
		showLoading();
		populateExValLookup( ExValLookUp.PROPERTY_TYPES, this );
		this.loadValuationDetails();
	}

	renderPropertyDetails() {
		if ( this.state.property ) {
			switch ( this.state.property.propertyTypeId ) {
				case TabuPropertyType.LAND :
					return this.renderLandRequestDetails();
				case TabuPropertyType.BUILDING :
					return this.renderBuildingRequestDetails();
				case TabuPropertyType.UNIT :
					return this.renderUnitRequestDetails();
				case TabuPropertyType.VILLA :
					return this.renderVillaRequestDetails();
				default:
					return <React.Fragment/>;
			}
		} else {
			return <React.Fragment/>;
		}
	}

	renderUnitRequestDetails() {
		let buildingName = LocaleUtil.getLocalValue( this.state.property.name );
		let unitNumber = this.state.property.unitNo;
		let type = getUnitTypeAndSubType( this.state.property );
		return <React.Fragment>
			<Item
				lbl={ Strings.building_name }
				val={ buildingName }/>
			<Item
				lbl={ Strings.unit_number }
				val={ unitNumber }/>
			<Item
				lbl={ Strings.type }
				val={ type }/>
		</React.Fragment>;
	}

	renderBuildingRequestDetails() {
		let buildingName = LocaleUtil.getLocalValue( this.state.property.name );
		return <React.Fragment>
			<Item
				lbl={ Strings.building_name }
				val={ buildingName }/>
		</React.Fragment>;
	}

	renderVillaRequestDetails() {
		let buildingName = LocaleUtil.getLocalValue( this.state.property.name );
		return <React.Fragment>
			<Item
				lbl={ Strings.building_name }
				val={ buildingName }/>
		</React.Fragment>;
	}

	renderLandRequestDetails() {
		return <React.Fragment>
			{ this.state.valuationScope.length > 0 && <Item
				lbl={ Strings.valuation_scope }
				val={ this.state.valuationScope }/> }
		</React.Fragment>;
	}

	renderRequestDetails() {
		return <>
			<div className="section-title mb-3">
				<h5>{ Strings.evaluation_request_details }</h5>
			</div>
			<div className="flex-grid">
				<Item
					lbl={ Strings.community }
					val={ this.state.community }/>
				<Item
					lbl={ Strings.municipality_number }
					val={ this.state.municipalityNumber }/>
				<Item
					lbl={ Strings.area_size_sq_mt }
					val={ this.state.areaSizeSqMtReq }/>

				{ this.renderPropertyDetails() }

				<Item
					lbl={ Strings.valuation_reason }
					val={ this.state.valuationReason }/>
				<Item
					lbl={ Strings.valuation_company_ev }
					val={ this.state.valuationCompany }/>
				<Item
					lbl={ Strings.notes }
					val={ this.state.notesReq }/>
			</div>
		</>;
	}

	renderValuationDetails() {
		return <>
			<div className="section-title mb-3 mt-3">
				<h5>{ Strings.evaluation_details }</h5>
			</div>
			<div className="flex-grid">
				<Item
					lbl={ Strings.valuator_name }
					val={ this.state.valuer }/>
				<Item
					lbl={ Strings.valuer_number }
					val={ this.state.valuerCardNumber }/>
				<Item
					lbl={ Strings.area_size_sq_mt }
					val={ this.state.areaSizeSqMt }/>
				<Item
					lbl={ Strings.area_size_sq_ft }
					val={ this.state.areaSizeSqFt }/>
				{ this.state.buildUpAreaSqMt.length > 0 && <Item
					lbl={ Strings.build_up_area_sq_mt }
					val={ this.state.buildUpAreaSqMt }/> }
				{ this.state.buildUpAreaSqFt.length > 0 && <Item
					lbl={ Strings.build_up_area_sq_ft }
					val={ this.state.buildUpAreaSqFt }/> }
				<Item
					lbl={ Strings.sq_mt_worth }
					val={ this.state.worthSqMt }/>
				<Item
					lbl={ Strings.sq_ft_worth }
					val={ this.state.worthSqFt }/>
				<Item
					lbl={ Strings.total_property_worth }
					val={ this.state.totalPropertyWorth }/>
				<Item
					lbl={ Strings.date_of_valuation }
					val={ this.state.dateOfValuation }/>
				<Item
					lbl={ Strings.notes }
					val={ this.state.notes }/>
			</div>
		</>;
	}

	renderRejectedValuationDetails() {
		return <>
			<div className="section-title mb-3 mt-3">
				<h5>{ Strings.evaluation_details }</h5>
			</div>
			<div className="flex-grid">
				<Item
					lbl={ Strings.valuator_name }
					val={ this.state.valuer }/>
				<Item
					lbl={ Strings.valuer_number }
					val={ this.state.valuerCardNumber }/>
				<Item
					lbl={ Strings.rejection_reason }
					val={ this.state.rejectionReason ? this.state.rejectionReason : "-" }/>
			</div>
		</>;
	}

	render() {
		return <React.Fragment>
			<PageContent title={ Strings.request_details }>
				<PageTitle title={ Strings.evaluation_request_details } paths={ [ MyRequestsBCItem ] }/>
				<div className="request-detail">
					{ this.renderRequestDetails() }

					{ this.state.rejectionReason && this.renderRejectedValuationDetails() }

					{ this.state.valuationCompleted && !this.state.rejectionReason && this.renderValuationDetails() }

					<div className="row">
						<div className="col-md-12 mt-3">
							{ this.state.documentURL &&
								<button
									onClick={ () => {
										window.open( this.state.documentURL );
									} } className="btn btn_1 btn_style1" type="submit"
									id="viewValuationDetails"> { Strings.view_certificate }
								</button> }
						</div>
					</div>
				</div>
			</PageContent>
		</React.Fragment>;
	}

	private loadValuationDetails() {
		const reqId = this.props.match.params.requestId;
		ExternalValuationApi.getValuationDetailsByRequestID( reqId ).then( ( response: any ) => {
			if ( response.response.request && response.response.request.length > 0 ) {
				this.setValuationDetails( response );
				let request = response.response.request[ 0 ];
				if ( request.requestEvaluationDetail ) {
					this.setState( { valuationCompleted: true } );
				}
				this.setState( { property: request.property } );
			}
			hideLoading();
		} ).catch( ( reason: any ) => {
			hideLoading();
			showErrorMessage( reason );
		} );
	}

	private getValuationScope( request: any ) {
		let scope = "";
		if ( request.property.propertyTypeId === TabuPropertyType.LAND ) {
			if ( request.property.propertyTypeId !== request.propertyTypeId ) {
				this.state.PropertyTypes?.map( ( type ) => {
					if ( type.id === request.propertyTypeId ) {
						scope = LocaleUtil.getLocalValue( type.name );
					}
				} );
			}
		}
		return scope;
	}

	private setValuationDetails = ( response: any ) => {
		if ( response.response.request && response.response.request.length > 0 ) {
			let request = response.response.request[ 0 ];
			let dmNo = request.property.landNo;
			let dmSubNo = request.property.landNo;
			if ( dmSubNo )
				dmNo += "-" + dmSubNo;
			this.setState( {
				community: LocaleUtil.getLocalValue( request.property.landArea.name ),
				municipalityNumber: dmNo,
				areaSizeSqMtReq: request.property.size,
				valuationScope: this.getValuationScope( request ),
				valuationReason: LocaleUtil.getLocalValue( request.evaluationReason.name ),
				valuationCompany: LocaleUtil.getLocalValue( request.evaluationCompany.name ),
				notesReq: request.requestNotes ? request.requestNotes : "",
			} );

			if ( request.requestEvaluationDetail ) {
				this.setState( {
					valuer: LocaleUtil.getLocalValue( request.requestEvaluationDetail.evaluatorName ),
					valuerCardNumber: request.requestEvaluationDetail.evaluatorNumber,
					areaSizeSqMt: request.requestEvaluationDetail.sizeSqMter ? request.requestEvaluationDetail.sizeSqMter.toFixed( 2 ) : "-",
					areaSizeSqFt: request.requestEvaluationDetail.sizeSqFt ? request.requestEvaluationDetail.sizeSqFt.toFixed( 2 ) : "-",
					buildUpAreaSqMt: request.requestEvaluationDetail.buildUpArea ? toSqMt( request.requestEvaluationDetail.buildUpArea ) : "",
					buildUpAreaSqFt: request.requestEvaluationDetail.buildUpArea ? request.requestEvaluationDetail.buildUpArea.toFixed( 2 ) : "",
					worthSqMt: request.requestEvaluationDetail.evaluationValueSqMter ? Strings.aed + CurrencyUtil.convertValueToCurrency( request.requestEvaluationDetail.evaluationValueSqMter ) : "-",
					worthSqFt: request.requestEvaluationDetail.evaluationValueSqFt ? Strings.aed + CurrencyUtil.convertValueToCurrency( request.requestEvaluationDetail.evaluationValueSqFt ) : "-",
					totalPropertyWorth: request.requestEvaluationDetail.totalEvaluationValue ? Strings.aed + CurrencyUtil.convertValueToCurrency( request.requestEvaluationDetail.totalEvaluationValue ) : "-",
					dateOfValuation: request.requestEvaluationDetail.evaluationDate ? formatAppDate( DateUtil.parseDate( request.requestEvaluationDetail.evaluationDate,
						"YYYY-MM-DDThh:mm:ss" ), "en" ) : "-",
					notes: request.requestEvaluationDetail.remarks,
					documentURL: request.document ? request.document.url : undefined,
					rejectionReason: request.reason ? request.reason : undefined
				} );
			}
		}
	};
}

function toSqMt( SqFt: number ) {
	return ( SqFt * 0.092903 ).toFixed( 2 );
}

function Item( props: { lbl: string; val: string } ) {
	const { lbl, val } = props;
	return <div key={ lbl }>
		<span>{ lbl }</span>
		<span>{ val }</span>
	</div>;
}

export default EVRequestDetails;
